"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importStar(require("react"));
require("./Modal.scss");
const Modal_scss_json_1 = __importDefault(require("./Modal.scss.json"));
const Modal_1 = require("@mui/base/Modal");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const utils_1 = require("@mui/base/utils");
const Modal = ({ isOpen = false, onClose, backdrop, children, renderContent, }) => {
    const handleClose = () => {
        onClose();
    };
    return (react_1.default.createElement(Modal_1.Modal, { "aria-labelledby": "unstyled-modal-title", "aria-describedby": "unstyled-modal-description", open: isOpen, onClose: handleClose, 
        // slots={{backdrop: BackdropSlot}} disable slots for make Backdrop component can pass props
        className: Modal_scss_json_1.default.modal },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Backdrop, { open: isOpen, backdrop: backdrop, onClose: handleClose }),
            react_1.default.createElement("div", { className: Modal_scss_json_1.default.content }, renderContent ? renderContent : children))));
};
exports.Modal = Modal;
const Backdrop = (0, react_1.forwardRef)((props, ref) => {
    const { open, backdrop, onClose } = props, other = __rest(props, ["open", "backdrop", "onClose"]);
    // check has custom backdrop
    const hasBackdrop = backdrop ? { backgroundColor: backdrop } : {};
    return (react_1.default.createElement("div", Object.assign({ ref: ref, className: (0, ClassNames_1.cl)(open && Modal_scss_json_1.default.backdrop), "aria-hidden": true, onClick: onClose, style: hasBackdrop }, other)));
});
// https://mui.com/base-ui/getting-started/customization/#overriding-subcomponent-slots
const BackdropSlot = (0, utils_1.prepareForSlot)(Backdrop);
//# sourceMappingURL=Modal.js.map